module.exports = __webpack_public_path__ + "img/liehuxing.f74317ea.png";